import { fileApiURl } from "API/urls/file.api";
import { axiosInstance } from "configs/axios";

export const uploadFileApi = async (formData) => {
  try {
    const response = await axiosInstance.post(fileApiURl.upload, formData);
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
